import { useEffect, useState } from "react";
import { client } from "@service/sanity";
import { SanityImageSource } from "@sanity/image-url/lib/types/types";

interface BodySystem {
  _id: string;
  name: string;
  flow: string;
  icon?: SanityImageSource;
}

interface Error {
  message: string;
}

const useGetBodySystem = () => {
  const [bodySystems, setBodySystems] = useState<BodySystem[] | null>(null);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchSanity = async () => {
      try {
        const data = await client.fetch(`*[_type == "bodysystem"]`);
        setBodySystems(data);
      } catch (e) {
        console.error("Failed to load body systems:", e);
        setErrorMessage(
          "Unable to load clinical categories. Please refresh and try again."
        );
      }
    };

    fetchSanity();
  }, []);

  return { bodySystems, errorMessage };
};

export default useGetBodySystem;